/**
 * @description Alpine magics
 */

import Alpine from 'alpinejs'

/**
 * Dispatches a custom event with the given name and detail.
 *
 * This overrides the `dispatch` magic function from Alpine, but keeps the same API.
 *
 * @param {Element} el - The element to dispatch the event on. If `window` is true, this will be `window`.
 * @param {string} name - The name of the event.
 * @param {Object} [detail={}] - The detail object for the event.
 * @param {boolean} [dispatchOnWindow=false] - Whether to dispatch the event on `window` instead of `el`.
 * 
 * @returns {void}
 */
let dispatch = function(el, name, detail = {}, dispatchOnWindow = false) {
  if (dispatchOnWindow) {
    el = window
  }

  el.dispatchEvent(
      new CustomEvent(name, {
          detail,
          bubbles: true,
          // Allows events to pass the shadow DOM barrier.
          composed: true,
          cancelable: true,
      })
  )
}

Alpine.magic('dispatch', el => dispatch.bind(dispatch, el))